module.exports = __webpack_public_path__ + "img/2.c4bf9629.gif";